import Indexdasboard from "../../components/dashboard/IndexDashbord";
import LabelTypography from "../../components/Typography/LabelTypography";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { Link } from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";
import { useEffect, useState, useCallback } from "react";
import GroupsIcon from "@mui/icons-material/Groups";
import { Api_Token } from "../../util/Api";
import {
  Card,
  Grid,
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Button,
  TextField,
  InputAdornment,
  CardContent,
  Divider,
  Pagination,
  IconButton,
} from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import { useTranslation } from "react-i18next";
import Datepicker from "react-tailwindcss-datepicker";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import ButtonTransparent from "../../components/Button/ButtonTransparent";
import SearchIcon from "@mui/icons-material/Search";

import ModelJourney from "../../components/popup/ModelCaisseJoureny";
import CustomAlert from "../../components/Alert/AlertCustomer";
import ModelCaisseNotAvailable from "../../components/popup/ModelCaisseNotAvailable";
import iconExcel from "../../assets/icon/iconsExcel.png";
export default function PagedashboardAdmin() {
  return <Indexdasboard Children={<PageDashboard />} />;
}

function PageDashboard() {
  const [StatistiqueGeneral, setStatistiqueGeneral] = useState({});
  const [Paiments, SetPaiments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filterById, setFilterById] = useState();
  const [openModelJourny, setOpenModelJourny] = useState(false);
  const [dataModel, setdataModel] = useState({
    store: "",
    montantDepart: "",
    dateOpen: "",
    dateClose: "",
  });
  const [CaisseNotAvailable, setCaisseNotAvailable] = useState(false);
  const [AlertEtat, setAlertEtat] = useState("inisial");
  const [AlertMessage, setAlertMessage] = useState("");
  const [DateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const { t } = useTranslation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    Api_Token.get(`statistique/getStatistiquedAdmin`)
      .then((response) => {
        setStatistiqueGeneral(response.data);
      })
      .catch((error) => {
        console.error("Error fetching statistics:", error);
      });
  }, []);
  const dataCard = [
    {
      titre: t("Magasins"),
      icon: <StoreIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral.magasins || 0,

      soustext: "View list",
      linkSousText: "/magasin",
    },
    {
      titre: t("Users"),
      icon: <GroupsIcon fontSize="large" color="primary" />,
      Number: StatistiqueGeneral.users || 0,

      soustext: "View list",
      linkSousText: "/users",
    },
  ];

  const fetchdata = useCallback(
    async (currentPage, rowsPerPage, DateRange, filterById) => {
      try {
        let url = `statistique/getListBookingsByDateAdmin?page=${
          currentPage + 1
        }&perPage=${rowsPerPage}`;
        const formattedStartDate = DateRange.startDate
          ? new Date(DateRange.startDate).toISOString().split("T")[0]
          : null;
        const formattedEndDate = DateRange.endDate
          ? new Date(DateRange.endDate).toISOString().split("T")[0]
          : null;
        if (formattedStartDate && formattedEndDate) {
          url += `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
        }
        if (filterById) {
          url += `&idTransaction=${filterById}`;
        }
        const response = await Api_Token.get(url);
        SetPaiments(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching checks:", error);
      }
    },
    []
  );
  async function exportData() {
    try {
      let url = `statistique/getListBookingsByDateAdminExcel`;
      const formattedStartDate = DateRange.startDate
        ? new Date(DateRange.startDate).toISOString().split("T")[0]
        : null;
      const formattedEndDate = DateRange.endDate
        ? new Date(DateRange.endDate).toISOString().split("T")[0]
        : null;
      if (formattedStartDate && formattedEndDate) {
        url += `?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
      }
      if (filterById) {
        url += formattedStartDate && formattedEndDate ? `&` : `?`;
        url += `idTransaction=${filterById}`;
      }
      const response = await Api_Token.get(url, { responseType: "blob" });
      if (response.status === 200) {
        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", "Transaction.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Failed to fetch the Excel file.", response);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  }

  useEffect(() => {
    fetchdata(page, rowsPerPage, DateRange, filterById);
  }, [fetchdata, page, rowsPerPage, DateRange, filterById]);
  async function handleSubmitNewCaisse() {
    try {
      await Api_Token.post(`/CaisseJourney/newCaisseJourney`, {
        ...dataModel,
        idCaisse: dataModel.store,
      });
      setAlertEtat("success");
      setAlertMessage(t("Journey created successfully!"));
      setOpenModelJourny(false);
    } catch (error) {
      console.error(error);
      if (error?.response?.status === 422) {
        const errorMessage =
          error?.response?.data?.error ||
          t("An error occurred while creating the journey. Please try again.");
        setAlertEtat("error");
        setAlertMessage(errorMessage);
      } else {
        setAlertEtat("error");
        setAlertMessage(
          t("An error occurred while creating the journey. Please try again.")
        );
      }
    }
  }

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {dataCard.map((data) => (
              <Grid item xs={12} md={4}>
                <CardDataButton data={data} />
              </Grid>
            ))}
            <Grid item xs={12} md={4} sx={{ height: "100%" }}>
              <Card sx={{ padding: "10%", borderRadius: "5%" }}>
                <Grid container spacing={3} sx={{ textAlign: "center" }}>
                  <Grid item xs={12}>
                    <ButtonTransparent onClick={() => setOpenModelJourny(true)}>
                      {t("Ouvrir une caisse")}​
                    </ButtonTransparent>
                  </Grid>
                  <Grid item xs={12}>
                    <ButtonTransparent
                      onClick={() => setCaisseNotAvailable(true)}
                    >
                      {t("Fermer une caisse")}​
                    </ButtonTransparent>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <Card sx={{ padding: "2%", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TitreGraphik>{t("List Bookings")}</TitreGraphik>
                  </Grid>

                  <Grid item xs={12}>
                    <IconButton onClick={exportData}>
                      <img src={iconExcel} height="10px" />
                    </IconButton>
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ width: "50%" }}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      placeholder={t("search by transaction id ")}
                      value={filterById}
                      onChange={(e) => {
                        setFilterById(e.target.value);
                      }}
                      sx={{
                        background: "#F8F8F8",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "black",
                          },
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon style={{ color: "black" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Datepicker
                      inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                      primaryColor={"blue"}
                      value={DateRange}
                      onChange={(newDateRange) => {
                        setDateRange(newDateRange);
                        setPage(0);
                      }}
                      showShortcuts={true}
                      showFooter={true}
                      popoverDirection="down"
                    />
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    border: "1px  #000",
                    borderRadius: "8px",
                  }}
                ></Box>
              </Box>

              <TableContainer
                sx={{ marginTop: "20px", width: "100%", minHeight: 450 }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="checks table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {t("ID Booking")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("ID Transaction")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Date")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("customers")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("N° de voyage")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("User")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Store")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("Montant")}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {t("payment method")}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {Paiments?.map((p) => (
                      <StyledTableRow key={p.id}>
                        <StyledTableCell align="center">
                          <Link to={`/DetaillBooking/${p.booking_id}`}>
                            #{p.booking_id}
                          </Link>
                        </StyledTableCell>{" "}
                        <StyledTableCell align="center">
                          <Link to={`/DetaillTransaction/${p.transaction_id}`}>
                            #{p.transaction_id}
                          </Link>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.created_at}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.customers}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.idVoyage}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.caisse_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <NumericFormatEnv Number={p.montant_paye} />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {p.payment_method}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Card>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <Box sx={{ width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {" "}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TitreGraphik>{t("List Bookings")}</TitreGraphik>
                    </Grid>

                    <Grid item xs={12}>
                      <IconButton onClick={exportData}>
                        <img src={iconExcel} height="10px" />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {" "}
                  <Grid container spacing={2} sx={{ width: "100%" }}>
                    <Grid item xs={12}>
                      <Card>
                        <TextField
                          fullWidth
                          placeholder={t("sherch by transaction id ")}
                          value={filterById}
                          onChange={(e) => {
                            setFilterById(e.target.value);
                          }}
                          sx={{
                            background: "#F8F8F8",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "black",
                              },
                              "&:hover fieldset": {
                                borderColor: "black",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black",
                              },
                            },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon style={{ color: "black" }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Card>
                    </Grid>
                    <Grid item xs={12}>
                      <Card>
                        <Datepicker
                          inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-[#F8F8F8] border border-gray-300 placeholder:text-balck-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
                          primaryColor={"blue"}
                          DateRange={DateRange}
                          onChange={(newDateRange) => {
                            setDateRange(newDateRange);
                            setPage(0);
                          }}
                          showShortcuts={true}
                          showFooter={true}
                          popoverDirection="down"
                        />
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {" "}
                  <Grid container spacing={2}>
                    {Paiments?.map((p) => (
                      <Grid item xs={12} sm={6} md={4} key={p.booking_id}>
                        <Card
                          variant="outlined"
                          sx={{ maxWidth: 345, width: "95%", margin: "auto" }}
                        >
                          <CardContent>
                            <LabelTypography textAlign="center">
                              {t("ID Booking")} :{" "}
                              <Link to={`/DetaillBooking/${p.booking_id}`}>
                                {" "}
                                #{p.booking_id}
                              </Link>
                            </LabelTypography>
                            <Divider sx={{ margin: "10px 0" }} />

                            <LabelTypography color="text.primary">
                              {t("ID Transaction")} :{" "}
                              <Link
                                to={`/DetaillTransaction/${p.transaction_id}`}
                              >
                                #{p.transaction_id}
                              </Link>
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("Date")} : {p.created_at}
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("customers")} : {p.customers}
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("N° de voyage")} : {p.idVoyage}
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("User")} : {p.name}
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("Store")} : {p.caisse_name}
                            </LabelTypography>
                            <Divider sx={{ margin: "10px 0" }} />

                            <LabelTypography color="text.primary">
                              {t("Montant")} :{" "}
                              <NumericFormatEnv Number={p.montant_paye} />
                            </LabelTypography>
                            <LabelTypography color="text.primary">
                              {t("payment method")}: {p.payment_method}
                            </LabelTypography>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          marginTop: "3%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Pagination
                          count={Math.ceil(totalCount / rowsPerPage)}
                          onChange={(event, newPage) => {
                            setPage(newPage - 1); // Adjust for 0-based indexing
                          }}
                          variant="outlined"
                          color="primary"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <ModelJourney
        open={openModelJourny}
        onClose={() => setOpenModelJourny(false)}
        formData={dataModel}
        setFormData={setdataModel}
        handleSubmit={handleSubmitNewCaisse}
        caisseDispo={true}
      />
      <ModelCaisseNotAvailable
        open={CaisseNotAvailable}
        onClose={() => setCaisseNotAvailable(false)}
      />
      <CustomAlert
        open={AlertEtat !== "inisial"}
        onClose={() => {
          setAlertEtat("inisial");
        }}
        etat={AlertEtat}
        message={AlertMessage}
      />
    </Box>
  );
}

const CardDataButton = ({ data }) => {
  return (
    <Card sx={{ padding: "8%", borderRadius: "5%" }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Grid container>
            <Grid item xs={12}>
              <LabelTypography sx={{ color: "gray", fontSize: "13px" }}>
                {data.titre}
              </LabelTypography>
            </Grid>
            <Grid item xs={12}>
              <TitreGraphik>{data.Number}</TitreGraphik>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
          }}
        >
          {data.icon}
        </Grid>
        {data?.textButton && (
          <Grid item xs={12} textAlign="center">
            <Link to={data.LinkButton}>
              <Button fullWidth>{data.textButton}</Button>
            </Link>
          </Grid>
        )}

        <Grid item xs={12} textAlign="center">
          <Link to={data.linkSousText} style={{ textDecoration: "none" }}>
            <LabelTypography
              sx={{
                fontSize: "15px",
                color: "#064C91",
                textDecoration: "underline",
              }}
            >
              {data.soustext}
            </LabelTypography>
          </Link>
        </Grid>
      </Grid>
    </Card>
  );
};
